/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Button } from '../../../../../components';
import { repository } from '@whizz/api-client';
import { useI18n } from '@whizz/react-i18n';
import type { AxiosError } from 'axios';
import type { SyntheticEvent } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { GLOBAL_ICONS, QUERIES_IDS } from '../../../../../util/vars';
import type { ToggleModalProps } from '../../../../../components/modal/types';
import { CancelButtonModal } from '../../../../../global';
import { ModalFooter } from '../../../../../components/modal/Modal';

const DeleteStaffModal = ({ toggle, toggleConfirm, data, onSuccess, onError }: Props): JSX.Element => {
  const { translate } = useI18n();
  const queryClient = useQueryClient();

  const firstName = data?.firstName;
  const lastName = data?.lastName;

  const mutationDelete = useMutation(
    repository.StaffRepository.deleteStaff,
    {
      onSuccess: () => {
        queryClient.invalidateQueries([ QUERIES_IDS.STAFF ]);
        onSuccess?.();
      },
      onError: (error: AxiosError<{ error: string }>) => {
        if (null == error.response) {
          return;
        }
        onError?.();
      },
    },
  );

  const handleSubmit = (event: SyntheticEvent) => {
    event.preventDefault();

    mutationDelete.mutate(data!.id);

    toggleConfirm(false);
  };

  const handleCancel = () => {
    toggleConfirm(false);
    toggle(true);
  };

  const WarningMessage = () =>
    <>
      <span className={'font-bold italic'}>
        {translate('pages.ROSTER_MANAGEMENT.STAFF.ADD_EDIT.DELETE_HINT_1', { firstName, lastName })}
      </span>
      <p>{translate('pages.ROSTER_MANAGEMENT.STAFF.ADD_EDIT.DELETE_HINT_2', { firstName })}</p>
    </>;

  const CancelButton = () =>
    <CancelButtonModal
      align={'start'}
      onClick={handleCancel}
    >
      {translate('pages.ROSTER_MANAGEMENT.STAFF.ADD_EDIT.BUTTONS.KEEP_ACCOUNT')}
    </CancelButtonModal>;

  const ConfirmButton = () =>
    <Button
      color={'negative'}
      icon={GLOBAL_ICONS.delete}
      isOutline
      onClick={handleSubmit}
    >
      {translate('pages.ROSTER_MANAGEMENT.STAFF.ADD_EDIT.BUTTONS.CONFIRM_DELETION')}
    </Button>;

  return (
    <form onSubmit={handleSubmit}>
      <div className={'container space-y-6'}>
        <WarningMessage />
      </div>
      <ModalFooter>
        <CancelButton />
        <ConfirmButton />
      </ModalFooter>
    </form>
  );
};

export default DeleteStaffModal;


export interface Props extends Pick<ToggleModalProps, 'toggle'> {
  data?: {
    id: number,
    firstName: string,
    lastName?: string | null,
  } | null;
  toggleConfirm: (value: boolean) => void;
  onSuccess?: () => void;
  onError?: () => void;
}
